import React from 'react'
import { Fieldset } from 'primereact/fieldset'
import { InputTextarea } from 'primereact/inputtextarea'
import { Button } from 'primereact/button'
import { DateTime } from 'luxon'

import {
  Btn,
  CustomCalendar,
  CustomCard,
  InputNumeroDecimal,
  InputPlacaVeiculo,
  InputText,
  InputTime,
} from '../../../../../components'
import { parseToMysqlFormat } from '../../../../../services/util/date.service'
import {
  formatVolumeAndUnits,
  sumVolumeAndUnits,
} from '../../../../../services/util/volume-and-units.service'

const PLACA_REGEX = /^[A-Za-z]{3}-\d[A-Za-z0-9]\d{2}$/
const HORA_REGEX = /^([01]\d|2[0-3]):[0-5]\d$/

export function buildForm(info) {
  return {
    nome_motorista: info.t1_driver_name || '',
    placa_veiculo: info.t1_vehicle_plate || '',
    data_chegada: info.t1_arrived_date ? DateTime.fromISO(info.t1_arrived_date).toJSDate() : null,
    horario_chegada: info.t1_arrived_time || '',
    codigo_lacre: info.codigo_lacre || '',
    temp_thermo_king: info.temp_thermo_king || '',
    obs_resumo_separacao: info.obs_resumo_separacao || '',
  }
}

function getErroFormulario(form) {
  if (!form.nome_motorista.trim()) return 'Nome do Motorista incorreto'
  if (!PLACA_REGEX.test(form.placa_veiculo)) return 'Placa do Veículo incorreta. Ex. ASD-7898'
  if (!(form.data_chegada instanceof Date) || isNaN(form.data_chegada)) {
    return 'Data de Chegada incorreta'
  }
  if (!HORA_REGEX.test(form.horario_chegada)) return 'Horário de Chegada incorreto'
  return null
}

function getTotal(itens) {
  return formatVolumeAndUnits(
    sumVolumeAndUnits(itens, item => ({
      quantity: item.quantidade,
      unitSku: item.unit_sku,
      caixaComPesoVariavel: item.caixa_com_peso_variavel,
    })),
  )
}

function EmitirResumoEtiqueta({
  status,
  form,
  faltas,
  sobras,
  onChange,
  onFinalizar,
  onImprimir,
  onErro,
}) {
  const isDisabled = status !== 'Finalizado'

  const onBtnFinalizarClicked = () => {
    const erro = getErroFormulario(form)
    if (erro) {
      onErro(erro)
      return
    }
    onFinalizar({
      ...form,
      placa_veiculo: form.placa_veiculo.toUpperCase(),
      data_chegada: parseToMysqlFormat(form.data_chegada),
    })
  }

  return (
    <div>
      <Fieldset legend="Informações do Veículo de Transferência">
        <div className="p-grid">
          <div className="p-col-3">
            <InputText
              disabled={isDisabled}
              marginTop={0}
              label="Nome do Motorista(*)"
              value={form.nome_motorista}
              onChange={value => onChange('nome_motorista', value)}
            />
          </div>
          <div className="p-col-2">
            <InputPlacaVeiculo
              disabled={isDisabled}
              marginTop={0}
              label="Placa do Veiculo(*)"
              value={form.placa_veiculo}
              onChange={value => onChange('placa_veiculo', value)}
            />
          </div>
          <div className="p-col-2">
            <CustomCalendar
              disabled={isDisabled}
              label="Data de Chegada(*)"
              marginTop={0}
              value={form.data_chegada}
              onChange={value => onChange('data_chegada', value)}
            />
          </div>
          <div className="p-col-2">
            <InputTime
              disabled={isDisabled}
              marginTop={0}
              label="Horário de Chegada(*)"
              value={form.horario_chegada}
              onChange={value => onChange('horario_chegada', value)}
            />
          </div>
          <div className="p-col-2">
            <InputText
              disabled={isDisabled}
              marginTop={0}
              label="Código do Lacre"
              value={form.codigo_lacre}
              onChange={value => onChange('codigo_lacre', value)}
            />
          </div>
        </div>
        <div className="p-grid">
          <div className="p-col-2">
            <InputNumeroDecimal
              disabled={isDisabled}
              marginTop={0}
              label="Temperatura Thermo King"
              value={form.temp_thermo_king}
              onChange={value => onChange('temp_thermo_king', value)}
            />
          </div>
        </div>
      </Fieldset>
      <div style={{ marginTop: 20 }}>
        <label style={{ fontSize: '0.8rem', color: '#14B0BF', display: 'block', marginBottom: 4 }}>
          Observação :
        </label>
        <InputTextarea
          disabled={isDisabled}
          autoResize
          rows={4}
          style={{ width: '100%', resize: 'none' }}
          placeholder="Digite uma observação sobre esta separação (opcional)"
          value={form.obs_resumo_separacao}
          onChange={e => onChange('obs_resumo_separacao', e.target.value)}
        />
      </div>
      <div className="p-grid" style={{ marginTop: 20 }}>
        <div className="p-col-3">
          <CustomCard title="Total de Faltas" subTitle="Vol./Caixa e Uni.">
            {getTotal(faltas)}
          </CustomCard>
        </div>
        <div className="p-col-3">
          <CustomCard title="Total de Sobras" subTitle="Vol./Caixa e Uni.">
            {getTotal(sobras)}
          </CustomCard>
        </div>
        <div className="p-col-12">
          <Btn disabled={isDisabled} onClick={onBtnFinalizarClicked}>
            Finalizar Resumo de Separação
          </Btn>
          <Button
            style={{ marginLeft: 10, backgroundColor: '#14B0BF', border: 'none' }}
            type="button"
            icon="pi pi-print"
            iconPos="left"
            label="Imprimir Resumo de Separação"
            disabled={status !== 'Resumo Emitido'}
            onClick={onImprimir}
          />
        </div>
      </div>
    </div>
  )
}

export default EmitirResumoEtiqueta
